module.exports = __webpack_public_path__ + "img/san-jose-room-4.12ff76bb.jpg";